export default __webpack_public_path__ + "static/media/cupcake-2.4e1691fa.jpg";